import { Box, CodeBlock } from '@customerio/pluma-components/react';
import * as styles from './bash-detail.css';

interface BashDetailProps {
  /** The bash command that was executed. */
  command: string;
}

export function BashDetail({ command }: BashDetailProps) {
  return (
    <Box className={styles.codeWrapper}>
      <CodeBlock code={command} language="bash" mode="dark" withCopyButton={true} />
    </Box>
  );
}
